<mat-list>
  <mat-list-item class="menu-item mat-padding-none list-container" [routerLink]="['/Home/ChangeSession']" detail="false" tabindex="-1">
    <div class="list-item">
      <mat-icon class="icon-style"><img [src]="path + 'change_session_settings_default.svg'"  alt="Change Session" /></mat-icon>
      <mat-label> CHANGE SESSION </mat-label>
    </div>
  </mat-list-item>
  <mat-list-item class="menu-item mat-padding-none list-container" button="true" (click)="obfuscateClientDetailsToggled()" detail="false" tabindex="-1">
    <div class="list-item">
      <mat-icon class="icon-style">{{ obfuscate ? 'visibility_off' : 'visibility' }}</mat-icon>
      <mat-label> {{ obfuscate ? 'UNOBFUSCATE' : 'OBFUSCATE' }} DETAILS </mat-label>
    </div>
  </mat-list-item>
  <mat-list-item class="menu-item mat-padding-none list-container" detail="false" tabindex="-1">
    <div class="list-item">
      <mat-icon class="icon-style"><img [src]="path + 'data_unit_default.svg'"  alt="Data Unit" /></mat-icon>
      <mat-label>DATA UNIT:</mat-label>
      <mat-select [value]="preferedGraphValue" (onChange)="changeGraphDataUnit($event)" class="settings-data-unit">
        <mat-option value="B">Byte</mat-option>
        <mat-option value="MB">MB</mat-option>
        <mat-option value="KB">KB</mat-option>
        <mat-option value="GB">GB</mat-option>
        <mat-option value="TB">TB</mat-option>
        <mat-option value="PB">PB</mat-option>
      </mat-select>
    </div>
  </mat-list-item>
  <!-- <mat-list-item class="menu-item mat-padding-none list-container" button="true" detail="false" (click)="openEndpointFile()" lines="none">
    <div class="list-item">
      <mat-icon class="icon-style">device_hub</mat-icon>
      <mat-label> View Client Endpoints </mat-label>
    </div>
  </mat-list-item> -->
</mat-list>
